<template>
    <div class="about">
        <Banner></Banner>
        <div class="m-main">
            <h2 class="u-hello2">{{qsName}}，你好！</h2>
            <h2 class="m-title4">2020（第六届）券商APP风云榜参选情况如下：</h2>

            <div class="m-part3">
                <h2 id="m_blk1" class="m-title5">
                    <span>奖项参选情况</span>
                </h2>
                <ul class="m-prize-blk">
                    <li
                        v-for="item in member_arr"
                        :key="item.key"
                        :class="['m-prize-item',item.sub_flag==1?'choose':'']"
                    >{{item.name}}</li>
                </ul>

                <h2 id="m_blk2" class="m-title5">
                    <span>参选资料情况</span>
                </h2>

                <div class="m-industry-box2">
                    <div class="m-industry-hy-form1 m-show">
                        <div class="m-industry-title3">
                            <h3>APP基本情况</h3>
                        </div>

                        <label class="m-industry-label1">
                            <span class="u-industry-name1">
                                <span class="start">*</span>参选APP名称：
                            </span>
                            <div class="m-industry-input1">
                                <p class="u-industry-des6">{{form.app_name}}</p>
                            </div>
                        </label>

                        <div class="m-chair-box clearfix">
                            <label class="m-industry-label1 fl">
                                <span class="u-industry-name2">
                                    <span class="start">*</span>日均活跃用户规模(万)：
                                </span>
                                <div class="m-industry-input3">
                                    <p class="u-industry-des6">{{form.app_rihuo}}</p>
                                </div>
                            </label>
                            <label class="m-industry-label1 fl">
                                <span class="u-industry-name2">累计总下载量(万)：</span>
                                <div class="m-industry-input3">
                                    <p class="u-industry-des6">{{form.app_down}}</p>
                                </div>
                            </label>
                        </div>

                        <div class="m-chair-box clearfix">
                            <label class="m-industry-label1 fl">
                                <span class="u-industry-name2">
                                    <span class="start">*</span>2020版本迭代次数：
                                </span>
                                <div class="m-industry-input3">
                                    <p class="u-industry-des6">{{form.app_iteration}}</p>
                                </div>
                            </label>
                            <label class="m-industry-label1 fl">
                                <span class="u-industry-name2">安卓应用市场覆盖数：</span>
                                <div class="m-industry-input3">
                                    <p class="u-industry-des6">{{form.app_android}}</p>
                                </div>
                            </label>
                        </div>

                        <label class="m-industry-label1">
                            <span class="u-industry-name1">港美股券商APP名称：</span>
                            <div class="m-industry-input1">
                                <p class="u-industry-des6">{{form.app_other_name}}</p>
                            </div>
                        </label>

                        <div class="m-chair-box clearfix">
                            <label class="m-industry-label1 fl">
                                <span class="u-industry-name2">
                                    <span class="start">*</span>日均活跃用户规模(万)：
                                </span>
                                <div class="m-industry-input3">
                                    <p class="u-industry-des6">{{form.app_other_rihuo}}</p>
                                </div>
                            </label>
                            <label class="m-industry-label1 fl">
                                <span class="u-industry-name2">累计总下载量(万)：</span>
                                <div class="m-industry-input3">
                                    <p class="u-industry-des6">{{form.app_other_down}}</p>
                                </div>
                            </label>
                        </div>

                        <div class="m-chair-box clearfix">
                            <label class="m-industry-label1 fl">
                                <span class="u-industry-name2">2020版本迭代次数：</span>
                                <div class="m-industry-input3">
                                    <p class="u-industry-des6">{{form.app_other_iteration}}</p>
                                </div>
                            </label>
                            <label class="m-industry-label1 fl">
                                <span class="u-industry-name2">安卓应用市场覆盖数：</span>
                                <div class="m-industry-input3">
                                    <p class="u-industry-des6">{{form.app_other_android}}</p>
                                </div>
                            </label>
                        </div>

                        <label class="m-industry-label1">
                            <span class="u-industry-name3">
                                <span class="start">*</span>重点智能服务以及用户使用情况：
                            </span>
                            <div class="m-industry-input2">
                                <p class="u-industry-des7">{{form.app_textarea1}}%；</p>
                            </div>
                        </label>

                        <label class="m-industry-label1">
                            <span class="u-industry-name3">近一年内APP服务升级情况：</span>
                            <div class="m-industry-input2">
                                <p class="u-industry-des7">{{form.app_textarea2}}</p>
                            </div>
                        </label>

                        <label class="m-industry-label1">
                            <span class="u-industry-name3">数字化赋能业务案例展示：</span>
                            <div class="m-industry-input2">
                                <p class="u-industry-des7">{{form.app_textarea3}}</p>
                            </div>
                        </label>

                        <label class="m-industry-label1">
                            <span class="u-industry-name3">
                                <span class="start">*</span>优秀运营案例以及营销活动展示：
                            </span>
                            <div class="m-industry-input2">
                                <p class="u-industry-des7">{{form.app_textarea4}}</p>
                            </div>
                        </label>

                        <label class="m-industry-label1">
                            <span class="u-industry-name3">
                                <span class="start">*</span>重点智能服务以及用户使用情况：
                            </span>
                            <div class="m-industry-input2">
                                <p class="u-industry-des7">{{form.app_textarea5}}</p>
                            </div>
                        </label>
                    </div>
                </div>

                <h2 id="m_blk3" class="m-title5">
                    <span>服务宣传&定向评测</span>
                </h2>
                <div class="m-industry-box2">
                    <div class="m-industry-hy-form1 m-show">
                        <label class="m-industry-label1">
                            <span class="u-industry-name4">定向评测服务名称：</span>
                            <div class="m-industry-input1">
                                <p class="u-industry-des6">{{form.test_name}}</p>
                            </div>
                        </label>

                        <label class="m-industry-label1">
                            <span class="u-industry-name4">基本服务介绍：</span>
                            <div class="m-industry-input1">
                                <p class="u-industry-des7">{{form.test_intro}}</p>
                            </div>
                        </label>

                        <label class="m-industry-label1">
                            <div class="m-chair-box clearfix">
                                <span class="u-industry-name4">重点服务推广需求名称：</span>
                                <div class="m-industry-input1">
                                    <p class="u-industry-des6">{{form.test_name2}}</p>
                                </div>
                            </div>
                        </label>
                    </div>
                </div>

                <h2 class="m-title5">
                    <span>同业评选情况</span>
                </h2>

                <div class="m-industry-box2">
                    <div class="m-industry-hy-form1 m-show">
                        <label class="m-industry-label1">
                            <span class="u-industry-name3">
                                <span class="start">*</span>您认为行业最佳券商APP（请列举5家或5家以上）：
                            </span>
                            <div class="m-industry-input2">
                                <p class="u-industry-des7">{{form.vote_textarea1}}</p>
                            </div>
                        </label>

                        <label class="m-industry-label1">
                            <span class="u-industry-name3">
                                <span class="start">*</span>您认为行业最具成长性券商APP（请列举5家或5家以上）：
                            </span>
                            <div class="m-industry-input2">
                                <p class="u-industry-des7">{{form.vote_textarea2}}</p>
                            </div>
                        </label>

                        <label class="m-industry-label1">
                            <span class="u-industry-name3">您认为哪家APP特色功能服务突出（请列举3家券商以及特色服务名称）：</span>
                            <div class="m-industry-input2">
                                <p class="u-industry-des7">{{form.vote_textarea3}}</p>
                            </div>
                        </label>
                    </div>
                </div>

                <div class="m-industry-box3">
                    <router-link to="/home" class="u-industry-btn2 fl">返回</router-link>
                    <!-- <router-link to="/print" class="u-industry-btn2 fr">报名情况打印</router-link> -->
                </div>
            </div>
        </div>
        <Foot></Foot>
        <Nav :navArr="NavDatas"></Nav>
    </div>
</template>
<script>
import Banner from "@/components/Banner";
// import List from "@/components/List";
// import List2 from "@/components/List2";
// import List3 from "@/components/List3";
import Foot from "@/components/Footer";
import Nav from "@/components/Nav";
export default {
    components: {
        Banner,
        Nav,
        // List,
        // List2,
        // List3,
        Foot
    },
    data() {
        return {
            form: {
                app_name: "",
                app_rihuo: "",
                app_down: "",
                app_iteration: "",
                app_android: "",
                app_other_name: "",
                app_other_rihuo: "",
                app_other_down: "",
                app_other_iteration: "",
                app_other_android: "",
                app_textarea1: "",
                app_textarea2: "",
                app_textarea3: "",
                app_textarea4: "",
                app_textarea5: "",
                test_name: "",
                test_intro: "",
                test_name2: "",
                vote_textarea1: "",
                vote_textarea2: "",
                vote_textarea3: ""
            },
            member_arr: pageDatas.prizeTypeDatas,
            qsName: "",
             NavDatas: pageDatas.navDatas.datas
            // ListDatas: [],
            // ListDatas2: [],
            // ListDatas3: []
        };
    },
    created() {
        this.detection();
        this.getLists();
    },
    methods: {
        getLists(index, ele) {
            var _this = this;
            // http://support.finance.sina.com.cn/service/api/openapi.php/AppBrokerVoteService.getVoteInfo?acode=zzzz_u&atype=qs
            let param = {
                url:
                    "//support.finance.sina.com.cn/service/api/openapi.php/AppBrokerVoteService.getVoteInfo",
                // ?acode=ajzq_020235f9c2af&atype=qs&hy_id=1
                acode: sessionStorage.getItem("acode")
                    ? sessionStorage.getItem("acode")
                    : "",
                atype: "qs"
            };
            // 发送 POST 请求
            this.$jsonp(param.url, {
                acode: param.acode,
                atype: param.atype
            })
                .then(function(response) {
                    // console.log(response);
                    if (response.result.status.code == 0) {
                        let datas = response.result.data.status;
                        if (datas) {
                            let adapterDatas = _this.adapter(datas.data);
                            _this.form = adapterDatas.list;
                            _this.isPrint = 1;
                        } else {
                            _this.isPrint = 0;
                        }
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        adapter(data) {
            var arr = data.participating_awards.split(",");
            for (var i = 0; i < this.member_arr.length; i++) {
                for (var j = 0; j < arr.length; j++) {
                    if (arr[i] == this.member_arr[i].id) {
                        this.member_arr[i].sub_flag = 1;
                    }
                }
            }
            if (!data.length) {
                return {
                    list: {
                        app_name: data.app_name,
                        app_rihuo: data.daily_activity_user,
                        app_down: data.downloads,
                        app_iteration: data.iterations_num,
                        app_android: data.android_market_num,
                        app_other_name: data.app_name_hk,
                        app_other_rihuo: data.daily_activity_user_hk,
                        app_other_down: data.downloads_hk,
                        app_other_iteration: data.iterations_num_hk,
                        app_other_android: data.android_market_num_hk,
                        app_textarea1: data.key_services_user_usage,
                        app_textarea2: data.upgrade_situation,
                        app_textarea3: data.pay_situation,
                        app_textarea4: data.digital,
                        app_textarea5: data.excellent_cases,
                        test_name: data.directional_service_name,
                        test_intro: data.directional_service_brief,
                        test_name2: data.directional_service_promotion_name,
                        vote_textarea1: data.best_broker_app,
                        vote_textarea2: data.best_growing_broker_app,
                        vote_textarea3: data.special_broker_app
                    }
                };
            }
        },
        detection() {
            let name = sessionStorage.getItem("name");
            // alert(name);
            if (!name) {
                this.$router.push({ path: "/" });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.m-part2 {
    margin-top: 20px;
}
</style>